import { Directive, HostListener, Input, inject } from '@angular/core';
import { NavigationService } from '../services/navigation.service';
import { AnalyticsService } from '../services/analytics.service';

/**
 * Unified lead-form CTA behavior. Applied as `[appQuoteCta]="'<location>'"`
 * on any `<a>` or `<button>`. Replaces per-component goToQuote() methods so
 * the CTA contract (preventDefault + analytics + sequenced scroll) lives in
 * exactly one place.
 *
 * Example:
 *   <a href="#get-a-call" appQuoteCta="hero">Get a quote</a>
 *   <button appQuoteCta="navbar_mobile">Get a Free Quote</button>
 *
 * The input value is forwarded as the analytics location tag.
 */
@Directive({
  selector: '[appQuoteCta]',
  standalone: true,
})
export class QuoteCtaDirective {
  /** Analytics location tag (e.g. 'hero', 'navbar_mobile', 'sticky'). */
  @Input('appQuoteCta') location = 'unknown';

  private nav = inject(NavigationService);
  private analytics = inject(AnalyticsService);

  @HostListener('click', ['$event'])
  onClick(event: Event): void {
    event.preventDefault();
    this.analytics.trackCtaClick(`${this.location}_get_quote`, this.location);
    void this.nav.goToQuoteForm();
  }
}
